import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BasicBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { color } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/color";
import { fontFamily } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontFamily";
import { fontSize } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontSize";
import { fontStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontStyle";
import { fontWeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontWeight";
import { lineHeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/lineHeight";
import { listStylePosition } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/listStylePosition";
import { listStyleType } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/listStyleType";
import { textAlign } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textAlign";
import { textTransform } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textTransform";
import {
  ContentProp,
  DesignProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "List",
  nameI18n: "builder_ui.block_type.list",
  version: 1,
  category: [BasicBlock],
  props: {
    items: {
      name: "Items",
      nameI18n: "builder_ui.prop_type.items",
      category: [ContentProp],
      prop: "other",
      type: "list",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        listStyleType: {
          ...listStyleType,
          defaultValue: defaultStyles.listStyleType,
        },
        listStylePosition: {
          ...listStylePosition,
          defaultValue: defaultStyles.listStylePosition,
        },
        color: {
          ...color,
          defaultValue: defaultStyles.color,
        },
        fontSize: {
          ...fontSize,
          defaultValue: defaultStyles.fontSize,
        },
        fontStyle: {
          ...fontStyle,
          defaultValue: defaultStyles.fontStyle,
        },
        fontWeight: {
          ...fontWeight,
          defaultValue: defaultStyles.fontWeight,
        },
        fontFamily: {
          ...fontFamily,
          defaultValue: defaultStyles.fontFamily,
        },
        lineHeight: {
          ...lineHeight,
          defaultValue: defaultStyles.lineHeight,
        },
        textAlign: {
          ...textAlign,
          defaultValue: defaultStyles.textAlign,
        },
        textTransform: {
          ...textTransform,
          defaultValue: defaultStyles.textTransform,
        },
      },
    },
  },
};
